<template>
  <div id ="preview" :class="[{'back': isShow},{'hidden': !isShow}] ">
    <!--<img src="http://p8vee8h46.bkt.clouddn.com//src/6fcb2be4498b3a88cae4f82b14a93850.jpg" height="90%" />-->
    <!--<div id="pdf" :class="{'hidden': !isPDF}">-->
      <canvas id = "the-canvas"></canvas>
    <!--</div>-->
    <!--<div id="img" :class="{'hidden': isPDF}">-->
      <!--<img src="http://p8vee8h46.bkt.clouddn.com//src/6fcb2be4498b3a88cae4f82b14a93850.jpg" />-->
    <!--</div>-->

    <!-- / / 添加关闭pdf功能-->
    <span :class = "{'close':isShow}" @click="closePdf" >close</span>
      <p class="foot" v-if="pdfDoc">
        <Button class="left" @click="onPrevPage" v-if="pageNum>1">上一页</Button>
        <Button class="right" @click="onNextPage" v-if="pageNum<pdfDoc.numPages">下一页</Button>
      </p>
  </div>
</template>
<script>
  import PDFJS from 'pdfjs-dist'
  export default {
    props: ['url'],
    data() {
      return {
        isShow: false,
        //通过该属性动态添加类，让pdf显示或隐藏
        pdfDoc: null,
        //可以打印发现是一个对象，里面有页数信息等
        pageNum: 1,
        pageRendering: false,
        pageNumPending: null,
        scale: 0.9
      }
    },
    computed: {
      isPDF () {
        return (this.fileExt(this.url)=='pdf');
      }
    },
    methods: {
      fileExt(file) {
        // console.info('filename:'+JSON.stringify(file));
        let filename = file;
        let index1=filename.lastIndexOf(".");
        let index2=filename.length;
        let type=filename.substring(index1+1,index2).toLowerCase();
        // console.info(type);
        return type;
      },
      closePdf() {
        this.isShow = false
      },
      showPDF(url) {
        this.isShow = true;
        let _this = this;

        if (_this.fileExt(url)=='pdf') {
          //pdf文件
          PDFJS.getDocument(url).then(function(pdf) {
            _this.pdfDoc = pdf;

            _this.renderPage(1);
          })
        } else {
          //图片
          _this.pdfDoc = null;
          _this.pageNum = 1;
          var canvas = document.getElementById("the-canvas");
          //获取对应的CanvasRenderingContext2D对象(画笔)
          var ctx = canvas.getContext("2d");

          var img = new Image();
          var curHeight=0,curWidth=0;

          //指定图片的URL
          img.src = url;
          //浏览器加载图片完毕后再绘制图片
          img.onload = function(){
            if (img.height>img.width) {
              curWidth = img.width*(800/img.height);
              curHeight = 800;
            } else {
              curWidth = 800;
              curHeight = img.height*(800/img.width);
            }



            canvas.height = curHeight;
            canvas.width = curWidth;
            ctx.drawImage(img, 0, 0, curWidth, curHeight);
            // ctx.drawImage(img, 10, 10, img.width*(800/img.height), 800);
          };



          // var c = document.getElementById("the-canvas");
          // c.height = viewport.height;
          // c.width = viewport.width;
          // var cxt = c.getContext("2d");
          // var img = new Image();
          // img.src = url;
          // cxt.drawImage(img,0,0);

        }


      },
      renderPage(num) {
        this.pageRendering = true;
        let _this = this;
        this.pdfDoc.getPage(num).then(function(page) {
          var viewport = page.getViewport(_this.scale);
          let canvas = document.getElementById('the-canvas');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          // Render PDF page into canvas context
          var renderContext = {
            canvasContext: canvas.getContext('2d'),
            viewport: viewport
          }
          var renderTask = page.render(renderContext);
          // Wait for rendering to finish
          renderTask.promise.then(function() {
            _this.pageRendering = false
            if (_this.pageNumPending !== null) {
              // New page rendering is pending
              this.renderPage(_this.pageNumPending);
              _this.pageNumPending = null
            }
          })
        })
      },
      queueRenderPage(num) {
        if (this.pageRendering) {
          this.pageNumPending = num
        } else {
          this.renderPage(num)
        }
      },
      onPrevPage() {
        if (this.pageNum <= 1) {
          return
        }
        this.pageNum--;
        this.queueRenderPage(this.pageNum)
      },
      onNextPage() {
        if (this.pageNum >= this.pdfDoc.numPages) {
          return
        }
        this.pageNum++;
        this.queueRenderPage(this.pageNum)
      }
    }
  }
</script>

<style scoped>
  .back {
    background-color: rgba(0, 0, 0, 0.788); position:fixed;
    width: 100%;
    height: 100%;
    top: 0; left: 0;
    text-align: center;
    padding: 20px;
    z-index: 100;
    overflow: scroll;
  }
  .close{
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 200;
    color: #fff;
    cursor: pointer;
  }
  .foot {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translate(-50%,0);
  }
</style>



// WEBPACK FOOTER //
// src/components/pdf-viewer/pdf.vue